"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function ScrollManager() {
  const pathname = usePathname();

  useEffect(() => {
    const main = document.getElementById("main-scroll-container");
    if (main) {
      main.scrollTop = 0;
    }
  }, [pathname]);

  return null;
}
